/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type PriceListFragment = {
  __typename: "PriceList"
  id: string
  title?: string | null
  isCurrent?: boolean | null
  isValid?: boolean | null
  validityKey?: string | null
}

export const PriceListFragmentDoc = gql`
  fragment PriceList on PriceList {
    id
    title
    isCurrent
    isValid
    validityKey
  }
`
